<template>
  <div style="margin-top: 0px">
    <DialogMissingSASDriver ref="dlgDriver"></DialogMissingSASDriver>
    <main-toolbar></main-toolbar>
    <v-layout justify-start row class="ml-4">
      <v-btn to="/" flat color="#6f6f6e" class="text-none pr-4" style="text-decoration: none">
        <v-icon>arrow_back</v-icon>
          {{'BUTT_NAV_BACK' | translate}}
      </v-btn>
    </v-layout>
      <v-container fluid>
        <v-layout justify-center>
            <v-flex xs12 sm8 md8>
            <div v-if="!isLoading">
            <v-card class="surfAndScanborder" color="transparent" flat>
              <v-card-text class="display-1 abstandObenklein textgrey" v-if="scanStarted">
                Scan läuft
              </v-card-text>
              <v-layout row wrap justify-center v-if="!btnDisabled">
                <v-flex justify-center>
                  <v-card-text class="body-1 font-weight-bold abstandObenklein">
                  </v-card-text>
                </v-flex>
              </v-layout>
            </v-card>
            </div>
            <div v-if="!btnDisabled">
            <v-card color="transparent" flat>
              <v-layout row wrap justify-center>
              <v-flex xs12 sm10 md8 lg6 d-flex>
              <v-btn :disabled="btnDisabled" large outline color="#6f6f6e" class="text-none font-weight-bold mb-5"
                     @click="startScan()">{{startText}}
              </v-btn>
              </v-flex>
              </v-layout>
              <v-layout row wrap justify-center>
                <v-flex xs12 sm10 md8 lg6 d-flex>
                  <v-alert
                    type="error"
                    :value="btnDisabled"
                  >
                    {{messageCode}}: {{message}}
                  </v-alert>
                </v-flex>
              </v-layout>
              <!-- Select Room -->
              <v-layout wrap justify-center v-if="!scanStarted && (sasClients && sasClients.length>0)" class="mt-3">
                <v-flex xs12 sm10 md8 lg6 d-flex>
                  <v-select
                    :items="sasClients"
                    v-model="selectedClient"
                    item-text="config.name"
                    return-object
                    @change="onChangeClient()"
                    solo
                    hint="Raum"
                    persistent-hint
                  ></v-select>
                </v-flex>
              </v-layout>
              <!-- Select Scanner Ende -->

              <!-- Select Scanner -->
              <v-layout wrap justify-center v-if="!scanStarted" class="mt-3">
                <v-flex xs12 sm10 md8 lg6 d-flex>
                  <v-select
                    :items="scannerList"
                    v-model="selectedScanner"
                    item-text="name"
                    item-value="id"
                    @change="onChangeDevice()"
                    solo
                    hint="Scanner"
                    persistent-hint
                  ></v-select>
                </v-flex>
              </v-layout>
              <!-- Select Scanner Ende -->
              <!-- Select Einseitig oder Beidseitig -->
              <v-layout wrap justify-center v-if="!scanStarted" class="mt-3">
                <v-flex xs12 sm10 md8 lg6 d-flex>
                  <v-select
                    :items="duplexList"
                    v-model="scanParameter.duplex"
                    item-text="name"
                    item-value="value"
                    solo
                    hint="Einseitig oder Beidseitig"
                    persistent-hint
                  ></v-select>
                </v-flex>
              </v-layout>
              <!-- Select Einseitig oder Beidseitig Ende -->
              <!-- Select Blatteinzug -->
              <v-layout wrap justify-center v-if="!scanStarted" class="mt-3">
                <v-flex xs12 sm10 md8 lg6 d-flex>
                  <v-select
                    :items="currentFeeders"
                    v-model="feederUnit"
                    item-text="title"
                    item-value="id"
                    solo
                    hint="Blatteinzug / Flachbett"
                    persistent-hint
                  ></v-select>
                </v-flex>
              </v-layout>
              <!-- Select Blatteinzug Ende -->
              <!-- Select Farbtiefe -->
              <v-layout justify-center v-if="!scanStarted" class="mt-3">
              <v-flex xs12 sm10 md8 lg6 d-flex>
                <v-select
                  :items="colors"
                  v-model="scanParameter.mode"
                  label="Farbtiefe"
                  solo
                  hint="Farbtiefe"
                  persistent-hint
                ></v-select>
              </v-flex>
              </v-layout>
              <!-- Select Farbtiefe Ende -->
              <!-- Select Auflösung -->
              <v-layout wrap justify-center v-if="!scanStarted" class="mt-3">
                <v-flex xs12 sm10 md8 lg6 d-flex>
                  <v-select
                    :items="resolutions"
                    v-model="scanParameter.resolution"
                    solo
                    hint="Auflösung"
                    persistent-hint
                  ></v-select>
                </v-flex>
              </v-layout>
              <!-- Select Auflösung Ende -->
              <v-card-text>
              </v-card-text>
            </v-card>
            </div>

            <v-layout row wrap justify-center abstandcardunten abstandOben v-if="btnDisabled">
              <v-flex row d-flex xs12 sm12 md6 fluid>
                <v-progress-circular
                  v-if="scanStarted"
                  :rotate="-90"
                  :size="150"
                  :width="15"
                  :value="state.value"
                  color="#6f6f6e"
                >
                  {{ state.value }}
                </v-progress-circular>
              </v-flex>
            </v-layout>

          </v-flex>
        </v-layout>
      </v-container>
     <!-- <v-layout row justify-center class="" v-if="!isLoading">
        <v-flex xs10 sm10 md10 lg12>
          <v-card class="surfAndScanborder" color="transparent" flat>
            <v-card-text class="display-1 font-weight-bold abstandObenklein" v-if="scanStarted">
              Scan läuft
            </v-card-text>
            <v-layout row wrap justify-center v-if="!btnDisabled">
              <v-flex justify-center>
                <v-card-text class="body-1 font-weight-bold abstandObenklein">
                </v-card-text>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center abstandcardunten v-if="!btnDisabled">
              <v-flex row d-flex xs10 sm10 md10 lg12 fluid justify-center class="">
                <v-btn :disabled="btnDisabled" large color="text-white" class="surfAndScanColor text-none"
                       @click="startScan()">{{startText}}
                </v-btn>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center v-if="!scanStarted">
              <v-flex row d-flex xs12 sm12 md6 fluid>
                <v-select
                  :items="colors"
                  v-model="scanParameter.mode"
                  label="Farbtiefe"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center v-if="!scanStarted">
              <v-flex row d-flex xs12 sm12 md6 fluid>
                <v-select
                  :items="resolutions"
                  v-model="scanParameter.resolution"
                  label="Auflösung"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center v-if="!scanStarted">
              <v-flex row d-flex xs12 sm12 md6 fluid>
                <v-select
                  :items="currentFeeders"
                  v-model="feederUnit"
                  item-text="title"
                  item-value="id"
                  label="Blatteinzug / Flachbett"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center v-if="!scanStarted">
              <v-flex row d-flex xs12 sm12 md6 fluid>
                <v-select
                  :items="duplexList"
                  v-model="scanParameter.duplex"
                  item-text="name"
                  item-value="value"
                  label="Vorderseite oder beide Seiten"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center v-if="!scanStarted">
              <v-flex row d-flex xs12 sm12 md6 fluid>
                <v-select
                  :items="scannerList"
                  v-model="selectedScanner"
                  item-text="name"
                  item-value="id"
                  @change="onChangeDevice()"
                  label="Scanner"
                ></v-select>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center abstandcardunten abstandOben v-if="btnDisabled">
              <v-flex row d-flex xs12 sm12 md6 fluid>
                <v-progress-circular
                  v-if="scanStarted"
                  :rotate="-90"
                  :size="150"
                  :width="15"
                  :value="state.value"
                  color="primary"
                >
                  {{ state.value }}
                </v-progress-circular>
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center abstandcardunten v-if="btnDisabled">
              <v-flex row d-flex xs12 sm12 md4 fluid justify-center class="">
                {{messageCode}}: {{message}}
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center abstandcardunten>
              <v-flex row d-flex xs12 sm12 md6 fluid justify-center class="">
                <v-btn small color="primary" v-if="existingJob" @click="gotoDownloads()">Herunterladen</v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout> -->
  </div>
</template>

<script>
import sas from 'surfandscan'
import mySortableDash from './../list/vue-sortable-dash.vue'
import MainToolbar from './../toolbar/MainToolbar'
import Vue from 'vue'
import DialogMissingSASDriver from '../dialogs/DialogMissingSASDriver'
export default {
  components: {DialogMissingSASDriver, mySortableDash, MainToolbar},
  name: 'page04',
  data () {
    return {
      wbHost: 'xxx',
      scannerList: [],
      selectedClient: null,
      isLoading: false,
      value: 0,
      scanStarted: false,
      sasIsActive: false,
      messageCode: '404',
      dpi: 300,
      config: {},
      fileName: '',
      sasClients: [],
      startText: 'START',
      message: 'broken',
      resolutions: [200, 300, 600, 1200],
      colors: [{
        text: '8 Bit Graustufen',
        value: 'GRAY_8'
      }, {
        text: '12 Bit Graustufen',
        value: 'GRAY_16'
      }, {
        text: '8 Bit Farbe',
        value: 'RGB_8'
      }, {
        text: '16 Bit Farbe',
        value: 'RGB_16'
      },
      {
        text: '32 Bit Farbe',
        value: 'RGB_32'
      }],
      btnDisabled: false,
      existingJob: {},
      dashConfig: {
        hasURLMaker: true,
        dashClass: 'marken',
        hasImage: true,
        hasText: true,
        link: '/PrintMedia/'
      },
      selectedScanner: null,
      state: {
        onScan: false,
        value: 1,
        pages: 0,
        variant: 'success'
      },
      duplexList: [
        {
          name: 'Einseitig',
          value: false
        },
        {
          name: 'Beiseitig',
          value: true
        }
      ],
      feederUnit: null,
      scanParameter: {
        duplex: false,
        feederUnit: -1
      },
      currentFeeders: [],
      feeders: [
        {
          title: 'Automatisch',
          id: -1
        },
        {
          title: 'Einzug 0',
          id: 0
        },
        {
          title: 'Einzug 1',
          id: 1
        },
        {
          title: 'Einzug 2',
          id: 2
        },
        {
          title: 'Einzug 3',
          id: 3
        }
      ],
      items: [
        {
          active: false,
          title: 'Was möchten Sie scannen?',
          subtitle: 'Mehrere Seiten'
        },
        {
          active: false,
          title: 'Einseitig oder Beidseitig?',
          subtitle: 'Beidseitig'
        },
        {
          active: false,
          title: 'Ihre Datei heißt:',
          subtitle: ''
        },
        {
          active: true,
          title: 'Herunterladen',
          subtitle: ''
        }
      ]
    }
  },
  methods: {
    gotoDownloads: function () {
      this.$router.push('/download')
    },
    backPage: function () {
      this.$router.push('/page3')
    },
    startScan: function () {
      this.scanStarted = true
      this.btnDisabled = true
      this.scanParameter = Vue.prototype.scanApi.getScanParameter()
      this.scanParameter.deviceAddress = this.selectedScanner
      if (this.feederUnit) {
        this.scanParameter.feederUnit = this.feederUnit.unit
      }
      var existingJob = Vue.prototype.scanApi.getCurrentJob()
      var expandJobId = null
      if (existingJob) {
        expandJobId = existingJob.id
        this.scanParameter.concatTaskId = expandJobId
      } else {
        this.scanParameter.concatTaskId = null
      }
      this.startText = 'Scan läuft'
      console.log('startScan', this.scanParameter)
      sas.scan(this.scanParameter, this.onScanSuccess, this.onError)
    },
    onScanComplete (data) {
      console.log('onScanComplete', data)
      this.startText = 'START'
      this.$router.push('/download')
    },
    checkStatus () {
      console.log('check status', this.currentScanJob)
      sas.getTaskStatus(this.currentScanJob.id, this.onScanSuccess)
    },
    downloadAsPDF () {
      var filePattern = this.scanParameter.fileNamePattern
      var taskId = this.currentScanJob.id
      sas.downloadTaskAsPDF(taskId, filePattern)
    },
    onChangeDevice () {
      console.log('onChangeDevice', this.selectedScanner)
      this.currentFeeders.splice(0, this.currentFeeders.length)
      var device = this.getDevice(this.selectedScanner)

      if (device) {
        for (let i = 0; i < device.units.length; i++) {
          var unit = device.units[i]
          var feed = {
            title: 'Einzug ' + unit,
            id: unit
          }
          if (unit.feeder === 'flatbed') {
            feed.title = 'Flachbett ' + unit.unit
          }
          if (unit.feeder === 'auto') {
            feed.title = 'Automatisch ' + unit.unit
          }
          if (unit.feeder === 'multi') {
            feed.title = 'Dokumenteneinzug ' + unit.unit
          }
          this.currentFeeders.push(feed)
        }
      }
    },
    getFeed (unit) {
      for (let i = 0; i < this.feeders.length; i++) {
        var feed = this.feeders[i]
        if (feed.id === unit.unit) return feed
      }
      return null
    },
    getFeedFromDevice (device, unitId) {
      if (!device) return null
      for (let i = 0; i < device.units.length; i++) {
        var feed = device.units[i]
        if (feed.unit === unitId) return feed
      }
      return null
    },
    getDevice (deviceId) {
      for (let i = 0; i < this.scannerList.length; i++) {
        var device = this.scannerList[i]
        if (device.id === deviceId) return device
      }
      return null
    },
    downloadAsTIFF () {
      var filePattern = this.scanParameter.fileNamePattern
      var taskId = this.currentScanJob.id
      sas.downloadTaskAsTIFF(taskId, filePattern)
    },
    onChangeClient () {
      console.log('onChangeClient', this.selectedClient)
    },
    onGetClients (clients) {
      if (clients && clients.list) {
        try {
          for (let i = 0; i < clients.list.length; i++) {
            var client = clients.list[i]
            client.config = JSON.parse(client.config)
          }
        } catch (err) {
          console.error(err)
        }

        this.sasClients = clients.list
      } else {
        this.sasClients = []
      }
    },
    onGetConfig (config) {
      this.config = config
      this.scanParameter.resolution = config.resolution
      this.scanParameter.mode = config.mode
      console.log('config', config)
      this.selectedScanner = config.deviceAddress
      sas.getDevices(this.onGetDevices)
    },
    onScanSuccess (data) {
      console.log('onScanSuccess', data)
      this.state.onScan = true
      if (data) {
        this.currentScanJob = data
        Vue.prototype.scanApi.setCurrentJob(data)
      }
      this.state.value = this.currentScanJob.progress
      this.state.pages = this.currentScanJob.pageNo
      var pageArray = this.currentScanJob.files
      this.messageCode = ''
      if (this.currentScanJob.message) {
        this.messageCode = this.currentScanJob.messageCode
      }

      this.message = this.currentScanJob.message

      for (let i = 0; i < pageArray.length; i++) {
        var taskId = this.currentScanJob.id
        var fileId = pageArray[i].id
        pageArray[i].imageUrl = sas.getThumbnailUrl(fileId, taskId)
      }

      Vue.prototype.scanApi.setPages(pageArray)
      if (this.currentScanJob.status !== 'done') {
        window.setTimeout(this.checkStatus, 800)
      } else {
        this.onScanComplete(this.currentScanJob)
      }
    },
    onGetCategories: function (data) {
      console.log('onGetCategories', data)
      this.categories = data.categories
      this.selectedCategories = this.scanParameter['categories']
    },
    onError (error, var1, var2) {
      console.log('onError', error, var1, var2)
      this.state.onScan = false
      this.startText = 'Scan starten'
    },
    onGetDevices (devices) {
      console.log('devices', devices, this.config.feederUnit)
      this.scannerList = devices
      this.onChangeDevice()
      var device = this.getDevice(this.selectedScanner)
      this.feederUnit = this.getFeedFromDevice(device, this.config.feederUnit)
    },
    sasIsAvailable: function (d) {
      console.log('sasIsAvailable', d)
      this.sasIsActive = true
      sas.getConfig(this.onGetConfig)
      sas.getClients(this.onGetClients)
    },
    sasIsMissing: function (d) {
      console.log('sasIsMissing', d)
      this.sasIsActive = false
      this.$refs.dlgDriver.open({})
    }
  },
  mounted () {
    if (Vue.prototype.$config.isCloud) {
      sas.setHost('https://localhost.surfandscan.com:8000')
    } else {
      if (location.protocol !== 'https:') {
        sas.setHost('http://localhost.surfandscan.com:8001')
      } else {
        sas.setHost('https://localhost.surfandscan.com:8000')
      }
    }
    sas.checkIsAvailable(this.sasIsAvailable, this.sasIsMissing)
    this.scanStarted = false
    this.selectedCategories = null
    this.scanParameter = Vue.prototype.scanApi.getScanParameter()
    this.fileName = this.scanParameter.fileNamePattern
    this.startText = 'Scan starten'
    this.existingJob = Vue.prototype.scanApi.getCurrentJob()
    if (this.existingJob) {
      this.startText = 'Scan erweitern'
    } else {
      this.startText = 'Scan starten'
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Page04.vue